import React from "react";
import Tooltip, { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import { styled } from "@mui/material/styles";
import { TooltipComponentProps } from "../../interface";

interface StyledTooltipProps extends TooltipProps {
  tooltipStyles?: React.CSSProperties;
}

const StyledTooltip = styled(
  ({ className, ...props }: StyledTooltipProps) => <Tooltip {...props} classes={{ popper: className }} />,
  {
    shouldForwardProp: (prop) => prop !== "tooltipStyles",
  },
)(({ tooltipStyles }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "var(--primary-text)",
    color: "var(--surface-white)",
    fontSize: "0.875rem",
    fontWeight: 500,
    fontFamily: "inherit",
    padding: "0.5rem 0.75rem",
    borderRadius: "0.25rem",
    gap: "0.5rem",
    ...tooltipStyles,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "var(--primary-text)",
  },
}));

const ToolTipComponent: React.FC<TooltipComponentProps> = (props) => {
  const { content, children, position, ...rest }: any = props;
  const hasContent = !!content;

  return (
    <StyledTooltip
      {...rest}
      placement={position || "top"}
      slots={{ transition: Zoom }}
      arrow
      title={hasContent ? content : ""}
    >
      {children ?? <span />}
    </StyledTooltip>
  );
};

ToolTipComponent.displayName = "ToolTipComponent";
export default ToolTipComponent;
